import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = () => {
  return APIHost() + ":3006/consumer/wallet";
};

// Wallet Transaction
export const getWalletTransactionList = params => {
  const url = `${baseURL()}/transaction`;
  return axios.post(url, params);
};

// Wallet Rebate
export const getRebatTransactionList = params => {
  let limit = "",
    offset = "";
  if (params.limit !== undefined) {
    limit = "/" + params.limit;
  }
  if (params.offset !== undefined) {
    offset = "/" + params.offset;
  }
  const url = `${baseURL()}/rebate_transaction${limit}${offset}`;
  return axios.get(url, params);
};

// Top Up
export const loadWalletTopUp = params => {
  const url = `${baseURL()}/reload`;
  return axios.post(url, params);
};
